<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.editPackage") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #ef3405">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Name Input -->
          <base-image-upload-input
            col="12"
            identifier="admin_image"
            :preSelectedImage="data.image.path"
            :placeholder="$t('PLACEHOLDERS.packageImage')"
            @selectImage="selectImage"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name_ar')"
            v-model.trim="data.name_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name_fr')"
            v-model.trim="data.name_fr"
            required
          />
          <!-- End:: Name Input -->
          <!-- Start:: Capacity Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.desc_ar')"
            v-model.trim="data.desc_ar"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.desc_fr')"
            v-model.trim="data.desc_fr"
            required
          />
          <!-- End:: Name Input -->

          <!-- Start:: perioud Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.package_duration')"
            v-model.trim="data.perioud"
            required
          />
          <!-- End:: perioud Input -->

          <!-- Start:: price Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.package_price')"
            v-model.trim="data.price"
            required
          />
          <!-- End:: price Input -->

          <!-- Start:: Deactivate Switch Input -->
          <!-- <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div> -->
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "EditPackage",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        name_ar: null,
        name_fr: null,
        desc_ar: null,
        desc_fr: null,
        perioud: null,
        price: null,
      },
      capacities: [],

      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    async getCapacities() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `capacities`,
        });
        this.capacities = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // Start:: validate Form Inputs
    validateFormInputs() {
      console.log("this.data.capacity", this.data.capacity);
      // this.isWaitingRequest = true;
      // if (!this.data.name_ar) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.name_ar"));
      //   return;
      // } else if (!this.data.name_en) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.name_en"));
      //   return;
      // } else if (this.data.capacity?.length == 0) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.capacity"));
      //   return;
      // } else if (!this.data.count_order) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.count_order"));
      //   return;
      // } else if (!this.data.perioud) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.duration"));
      //   return;
      // } else if (!this.data.price) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.price"));
      //   return;
      // } else {
      this.submitForm();
      // }
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data

      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }
      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_fr) {
        REQUEST_DATA.append("name[fr]", this.data.name_fr);
      }
      if (this.data.desc_ar) {
        REQUEST_DATA.append("description[ar]", this.data.desc_ar);
      }
      if (this.data.desc_fr) {
        REQUEST_DATA.append("description[fr]", this.data.desc_fr);
      }
      if (this.data.perioud) {
        REQUEST_DATA.append("days", this.data.perioud);
      }
      if (this.data.price) {
        REQUEST_DATA.append("price", this.data.price);
      }
      REQUEST_DATA.append("_method", "put");
      try {
        await this.$axios({
          method: "POST",
          url: `packages/${this.$route.params?.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/packages/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    // start show data
    async showPackage() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `packages/${this.$route.params?.id}`,
        });
        // const capacity_format1 = res.data.data.Package.capacities;
        // const capacity_format2 = capacity_format1.map(item => ({
        //     id: item.id,
        //     name: item.name.en,
        //     name_ar: item.name.ar,
        //     name_en: item.name.en,
        //     is_active: item.is_active,
        //     double_perioud: item.double_perioud,
        //     count_finish_order: item.count_finish_order,
        //     created_at: item.created_at.split("T")[0]
        // }));
        this.data.image.path = res.data.data.Package.image;
        this.data.name_ar = res.data.data.Package.name_ar;
        this.data.name_fr = res.data.data.Package.name_fr;
        this.data.desc_ar = res.data.data.Package.description_ar;
        this.data.desc_fr = res.data.data.Package.description_fr;
        this.data.perioud = res.data.data.Package.days;
        this.data.price = res.data.data.Package.price;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
    // end show data
  },

  created() {
    this.showPackage();
    this.getCapacities();
  },
};
</script>
